module.exports = __webpack_public_path__ + "img/gi.944d9dba.svg";